<template>
	<div class="app-header" v-if="headerShow">
		<div class="app-header-left"></div>
		<img class="logo" src="@/assets/images/Kominato_logo.png" alt="">
		<div class="user-box" v-if="show">
			<div @click="goMyPage">マイページ
				<img src="@/assets/images/user.png" alt="">
			</div>
		</div>
	</div>
</template>
<script>
import DebugDateMixin from "@/mixins/DebugDateMixin";
export default {
	mixins: [ DebugDateMixin ],
	data() {
		return {
			show: false,
			headerShow: true,
		}
	},
	created() {
	},
	mounted() {
		// チケットページではヘッダーを非表示にする
		if (this.$route.name == 'ticket') {
			this.headerShow = false
		} else {
			this.headerShow = true
		}
		this.handleTop();
	},
	watch: {
		$route(to, from) {
			if (to.name == 'ticket') {
				this.headerShow = false
			} else {
				this.headerShow = true
			}
		}
	},
	methods: {
		handleTop() {
			this.show = true;
		},
		goMyPage() {
			const query = {};
			this.$router.push({
				name: 'home',
				query: this.preserveDebugDate(query),
			})
		}
	}
}
</script>
<style lang="scss" scoped>
	.app-header {
		height: 80px;
		background: #FFFFFF 0% 0% no-repeat padding-box;
		position: relative;
		border-bottom: 1px solid #D3D9DB;

		.app-header-left {
			display: inline-block;
			width: 16px;
			height: 79px;
			background: #63B6CF 0% 0% no-repeat padding-box;
		}

		.logo {
			position: absolute;
			top: 24px;
			left: 30px;
		}

		.user-box {
			float: right;
			margin-top: 24px;
			margin-right: 25px;

			.username {
				display: inline-block;
				color: #75838C;
				font-size: 14px;
				font-family: 'メイリオ';
				font-weight: bold;
			}

			div {
				display: inline-block;
				width: 160px;
				height: 32px;
				cursor: pointer;
				color: #fff;
				background: #63B6CF 0% 0% no-repeat padding-box;
				border-radius: 6px;
				position: relative;
				line-height: 32px;
				text-align: center;
				font-size: 12px;
				font-family: 'メイリオ';
				font-weight: bold;
				margin-left: 12px;

				img {
					position: absolute;
					width: 18px;
					height: 18px;
					top: 7px;
					right: 8px;
				}
			}
		}
	}

	@media screen and (max-device-width: 640px) {
		.app-header {
			height: 56px;
			background: #FFFFFF 0% 0% no-repeat padding-box;
			position: relative;
			border-bottom: 1px solid #D3D9DB;

			.app-header-left {
				display: inline-block;
				width: 8px;
				height: 55px;
				background: #63B6CF 0% 0% no-repeat padding-box;
			}

			.logo {
				width: 134px;
				height: 24px;
				position: absolute;
				top: 16px;
				left: 15px;
			}

			.user-box {
				float: right;
				margin-top: 12px;
				margin-right: 8px;

				.username {
					display: inline-block;
					color: #75838C;
					font-size: 12px;
					font-family: 'メイリオ';
					font-weight: bold;
				}

				div {
					display: inline-block;
					width: 92px;
					height: 32px;
					cursor: pointer;
					color: #fff;
					background: #63B6CF 0% 0% no-repeat padding-box;
					border-radius: 6px;
					position: relative;
					line-height: 32px;
					text-align: center;
					font-size: 12px;
					font-family: 'メイリオ';
					font-weight: bold;
					margin-left: 12px;
					text-align: left;
					padding-left: 8px;

					img {
						position: absolute;
						width: 18px;
						height: 18px;
						top: 7px;
						right: 8px;
					}
				}
			}
		}
	}
</style>